/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Auth0SsoTokenResponse } from '../models/Auth0SsoTokenResponse';
import type { RefreshForBearerTokenRequestDto } from '../models/RefreshForBearerTokenRequestDto';
import type { TokenRequestDto } from '../models/TokenRequestDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { request as __request } from '../core/request';

export class Auth0SsoAuthService {

    /**
     * Exchange authorization code for Auth0 SSO tokens
     * @param requestBody
     * @returns Auth0SsoTokenResponse Successfully exchanged authorization code for token.
     * @throws ApiError
     */
    public static auth0SsoAuthControllerExchangeCodeForToken(
        requestBody: TokenRequestDto,
    ): CancelablePromise<Auth0SsoTokenResponse> {
        return __request({
            method: 'POST',
            path: `/auth/auth0-sso/token`,
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Failed to exchange code for token.`,
            },
        });
    }

    /**
     * Obtain a new Auth0 SSO id_token by refresh token
     * @param requestBody
     * @returns Auth0SsoTokenResponse Successfully obtained a new bearer token by refresh token.
     * @throws ApiError
     */
    public static auth0SsoAuthControllerExchangeRefreshForBearerToken(
        requestBody: RefreshForBearerTokenRequestDto,
    ): CancelablePromise<Auth0SsoTokenResponse> {
        return __request({
            method: 'POST',
            path: `/auth/auth0-sso/refresh`,
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Failed to obtain a new bearer token by refresh token.`,
            },
        });
    }

}